export default "__VITE_ASSET__xZTJ_Siv__"